/**
 * AWS Cognito Configuration
 * Environment variables loaded from:
 * - localhost: .env.development
 * - AWS Amplify: Console environment variables
 */

export const cognitoConfig = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || '',
  userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || ''
};

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolWebClientId
    }
  }
};

export default cognitoConfig;